import Axios from 'axios';
import Vue from 'vue';
import i18n from '@/i18n';
import { API_HOST } from '@/config/app-const';

const state = {
  noorContext: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_NOOR_CONTEXT_BUSY: (state, payload) => {
    state.noorContext.isBusy = payload;
  },
  LOAD_NOOR_CONTEXT_SUCCESS: (state, payload) => {
    state.noorContext.data = payload;
    state.noorContext.error = null;
  },
  LOAD_NOOR_CONTEXT_FAIL: (state, payload) => {
    state.noorContext.error = payload;
  },

  UPDATE_NOOR_CONTEXT_BUSY: (state, payload) => {
    state.noorContext.isBusy = payload;
  },
  UPDATE_NOOR_CONTEXT_SUCCESS: (state, payload) => {
    state.noorContext.data = payload;
    state.noorContext.error = null;
  },
  UPDATE_NOOR_CONTEXT_FAIL: (state, payload) => {
    state.noorContext.error = payload;
  }
};

const actions = {
  getContext: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_NOOR_CONTEXT_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .get(`${API_HOST}/projects/${projectId}/noor_context`, config)
      .then(response => {
        commit('LOAD_NOOR_CONTEXT_SUCCESS', response.data.context)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_NOOR_CONTEXT_FAIL', error)
      })
      .finally(() => commit('LOAD_NOOR_CONTEXT_BUSY', false));
  },

  updateContext: ({ commit, rootState }, { projectId, data }) => {
    commit('UPDATE_NOOR_CONTEXT_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    return Axios
      .put(`${API_HOST}/projects/${projectId}/noor_context`, 
      data,
      config)
      .then(response => {
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.context_update_success')
        });
        commit('UPDATE_NOOR_CONTEXT_SUCCESS', response.data.context);
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('UPDATE_NOOR_CONTEXT_FAIL', error)
      })
      .finally(() => commit('UPDATE_NOOR_CONTEXT_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};